import {ApiDatasource} from '../../adapters/io/datasources/ApiDatasource';
import {unwrap} from '../../adapters/io/network/HttpResponse';
import {formatText} from '../../adapters/io/network/utils';
import {ApiDatasourceSpec} from '../../core/datasource';
import {AuthState} from '@okta/okta-auth-js';
import {buildHeader} from './utils/Utils';
import {EndpointSku} from "./SkuRepository";

export const getAppInfo = (
    authState: AuthState,
    datasource: ApiDatasourceSpec = new ApiDatasource(),
    uriFormatter: (uri: string, ...params: unknown[]) => string = formatText
): Promise<object> => {
    const params = new Map();

    return datasource.remote
        .getData<object>(
            uriFormatter(EndpointAppInfo.endPoint.concat(EndpointAppInfo.getAppInfo), {}),
            buildHeader(authState), params)
        .then(unwrap);
};

export const EndpointAppInfo = {
    endPoint: '/end-point/app-info',
    getAppInfo: ''
};
